import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FilterService {

  generateFilter(event: any, properties: string[]): HttpParams {
    const filterData: { [key: string]: string } = {};

    if (!event) {
      return new HttpParams();
    }

    properties.forEach(property => {
      const value = event[property];
      if (value) {
        filterData[property] = this.processValue(property, value);
      }
    });

    return new HttpParams({ fromObject: filterData });
  }

  private processValue(property: string, value: any): string {
    if (property === 'cpf') {
      return this.removeCpfMask(value);
    }
    if (property === 'matricula') {
      return this.convertToUppercase(value);
    }
    if (property.includes('data')) {
      return this.formatDate(value);
    }
    return value;
  }

  private removeCpfMask(value: string): string {
    return value.replace(/\D/g, '');
  }

  private convertToUppercase(value: string): string {
    return value.toUpperCase();
  }

  private formatDate(value: any): string {
    if (value instanceof Date) {
      const month = (value.getMonth() + 1).toString().padStart(2, '0');
      const day = value.getDate().toString().padStart(2, '0');
      return `${value.getFullYear()}-${month}-${day}`;
    }
    if (typeof value === 'string') {
      const [day, month, year] = value.split('/');
      return `${year}-${month}-${day}`;
    }
    return value;
  }
}
